

//BV review event listener
$(document).ready(function(){

  //facet price range option select
  $(document).on('click', '.js-price-range-change', function(e){
    e.preventDefault();
    $('.js-price-range-change').removeClass('active');
    $(this).addClass('active');
    let $priceRangeEl = $(this).parents('price-range');
    let min = $(this).data('min-price');
    let max = $(this).data('max-price');
    let label = $priceRangeEl.data('filter-label');
    let $priceInputs = $priceRangeEl.find('input');
    let $gteInput = $priceInputs.eq(0);
    let $lteInput = $priceInputs.eq(1);

    if($(this).hasClass('js-price-range-all')){
      $gteInput.val("");
      $lteInput.val("");
    }else{
      $gteInput.val(min);
      $lteInput.val(max);
    }


    $priceInputs.get(0).dispatchEvent(new Event('input', {
      bubbles: true
    }))

    /*
    document.getElementById(`${label}-GTE`).dispatchEvent(new Event('input', {
      bubbles: true
    }))
    */

    //close menu drawer on mobile
    $(this).closest('.mobile-facets__wrapper').find('summary').first().click()

  })
  

});




// price change listener (MutationObserver + custom event)
$(document).on("productPagePriceChange", PriceChangeHandler);

function PriceChangeHandler() {
  var $priceEl = $("#ProductPrice-product [data-product-price]");
  if ($priceEl.length === 0) return;

  var newPrice = $priceEl.text();
  $(".product-buy-now-price .money").text(newPrice);
  $(".product-page-bottom-fixed-atc-container .money").text(newPrice);
}

function initPriceObserver() {
  var priceNode = document.querySelector(
    "#ProductPrice-product [data-product-price]"
  );
  if (!priceNode || !window.MutationObserver) return;

  var observer = new MutationObserver(function () {
    PriceChangeHandler();
  });

  observer.observe(priceNode, {
    characterData: true,
    childList: true,
    subtree: true,
  });
}

initPriceObserver();


//ajax add to cart product grid

$(document).on(
  "click",
  ".product-grid-add-js,.qv-add-to-cart, .js-quick-add, .js-product-related-video-player-atc",
  function (e) {
    e.preventDefault();
    var quantity = 1,
      productID = $(this).data("product-id"),
      variantID = $(this).data('id'),
      collectionID = $(this).data("collection");

    var form_data = {};
    form_data["id"] = variantID;
    form_data["form_type"] = "product";

    const properties = {};

    $(this).parents('.js-product-form').find('input[name^="properties["]').each(function() {
      var match = this.name.match(/^properties\[(.+)\]$/);
      if (match) {
        var key = match[1];
        properties[key] = $(this).val();
      }
    });

    form_data['properties'] = properties
    //console.log('qv-form: ', form_data)

    

    addItem(form_data, collectionID);
  }
);
var addItem = function (data, collectionID) {
  var sectionParams =
    window.theme &&
    theme.Drawer &&
    typeof theme.Drawer.getSectionRequestParams === "function"
      ? theme.Drawer.getSectionRequestParams()
      : null;
  if (sectionParams && sectionParams.id) {
    data.sections = sectionParams.id;
    if (sectionParams.url) {
      data.sections_url = sectionParams.url;
    }
  }

  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    dataType: "json",
    data: data,
    success: function (product) {
      theme.Drawer.addToCartOkay(product, collectionID);
    },
    error: addToCartFail,
  });
};

var addToCartFail = function (obj, status) {
  $("form .errors").remove();
  $(".product__add__success").addClass("product__add__success--hide");
  $(
    "<div class='errors'>" +
      obj.responseJSON.message + 
      "</div>"
  ).appendTo("form");
};
